/* tslint:disable */
import Moment from 'moment';
import { Log } from 'ng2-logger';
import React, { Dispatch } from 'react';
import { connect } from 'react-redux';
import { Modal, UncontrolledTooltip } from 'reactstrap';
import { Notification } from '../../../../components/notification/main';
import Paginate from '../../../../components/table/paginate';
import { Common } from '../../../../core/common';
import Translator from '../../../../core/i18n';
import { IAction, IAppState } from '../../../../models/action/core';
import {
    FilterInitialValues,
    IAssignmentGradeFiles,
    IAssignmentGradeProps,
    IAssignmentGradeStudentItem
} from '../../../../models/components/assignment-grade-modal';
import * as Actions from '../../../../store/actions/coursePage';
import { SecureImage } from '../../../core/secureImage';
import Loading from '../../../loading/loading';
import ProgressCircle from '../../../progress-circle/progress-circle';
import logger from 'redux-logger';
import { OverlayTrigger, Popover } from 'react-bootstrap';
import { MessagesService } from '../../../../api/message-services';
import BaseModal from '../../../../modal/base-modal/main';
import BulkGrade from './bulk-grade-modal';
import { BackgroundService } from '../../../../api/background-service';
import ActivityAssignmentGradeModalTabs from './grade-modal-tabs/main';
import ContentLoader from 'react-content-loader';
import { Redirect } from 'react-router-dom';
import ChatPanel from '../../../../pages/messages/chatPanel';
import * as MessagePageActions from '../../../../store/actions/messages';
import SearchInput from '../../../input/text/search-input';
import Tooltip from '../../../tooltip/main';
import { GradeInfoTypes } from '../../../../models/enums/GradeInfoTypes';
import { SecurityContextType, SecurityPermissionType } from '../../../../core/SecurityContext';
import { Button } from '../../../ui-elements/main';

const _lodash = require('lodash');
const _logger = Log.create('Processing Activity');
const T = Translator.create();
let _common: Common;
const messagesService = new MessagesService();
const _backgroundService = new BackgroundService();

class ReportModal extends React.Component<IAssignmentGradeProps, any> {
    constructor(props: any) {
        super(props);
        _common = new Common();

        this.state = {
            filters: Object.assign({}, FilterInitialValues),
            isSearchBoxOpen: false,
            derivedState: false,
            scoreTable: [],
            bulkScore: -1,
            currentTab: '_classStudentsTab',
            isMessageModalOpen: false,
            handleMessageModal: (isOpen: boolean) => {
                return new Promise<void>((resolve) => {
                    this.setState({ isMessageModalOpen: isOpen }, resolve);
                });
            },
            isGradeInfoType: GradeInfoTypes.TotalStudent
        };

    }


    componentDidMount() {
        this.getAssignmentGradeInformation();
        this.getAssignmentGradeStudentList();
    }

    componentDidUpdate(prevProps: Readonly<IAssignmentGradeProps>, prevState: Readonly<any>, snapshot?: any): void {
        if (prevState.currentTab !== this.state.currentTab) {
            this.onPageChange(1)
        }
    }

    getAssignmentGradeInformation() {
        let classId = '-1';
        const activityId = this.props.assignmentGradeInformation && this.props.assignmentGradeInformation.activityId;
        const groupId = this.props.isProjectSubActivity && this.props.groupId ? this.props.groupId : '0';

        this.props.dispatch(Actions.getAssignmentGradeInformation(classId, this.props.activityId! ? this.props.activityId! : activityId!, groupId, false, 'getAssignmentGradeInformation', 'get'));
    }

    getAssignmentGradeStudentList() {
        const classId = this.state.currentTab === '_allStudentsTab' ? '-1' : this.props.coursePageClassId!;
        const activityId = this.props.assignmentGradeInformation && this.props.assignmentGradeInformation.activityId;
        const groupId = this.props.isProjectSubActivity && this.props.groupId ? this.props.groupId : '0';
        this.props.dispatch(
            Actions.getAssignmentGradeStudentList(classId, this.props.activityId, groupId, this.state.filters, this.state.isGradeInfoType, false, 'getAssignmentGradeStudentList', 'get')
        );
    }

    triggerSearchBox(bool: boolean) {
        this.setState({
            ...this.state,
            isSearchBoxOpen: bool
        });
    }

    clickToDownload(urli: string, name: string) {
        let linkUrl: string = window.appSettings.API_URL;
        if (urli.startsWith('/'))
            linkUrl += urli + '/download';
        else
            linkUrl += '/' + urli + '/download';

        _common.DownloadLink(linkUrl, name);
    }

    downloadZip = async (allClasses: boolean) => {
        // let classId = '';
        // let activityId = '';
        // if (this.props.activityId) {
        //     activityId = this.props.activityId
        // } else {
        //     activityId = this.props.assignmentGradeInformation!.activityId;
        // }
        // _logger.data('melih', allClasses);
        // if (this.props.assignmentGradeInformation) {
        //     _logger.data('melih', this.props.assignmentGradeInformation.isCommon);
        //     classId = allClasses ? '-1' : this.props.coursePageClassId!;
        // }
        // _logger.data('melih', classId);
        // if (this.props.isProjectSubActivity) {
        //     classId = '-1';
        // }

        // Notification.setNotification('info', T.t('r_assignment_all_download_info'), 'topRight');
        // const url = window.appSettings.API_URL + '/api/assignment/allfiles/' + classId + '/' + activityId;

        // _common.DownloadZip(url, T.t('r_assignment_files'));

        try {
            let classId = allClasses ? '-1' : this.props.coursePageClassId!;
            let activityId = '';
            if (this.props.activityId) {
                activityId = this.props.activityId
            } else {
                activityId = this.props.assignmentGradeInformation!.activityId;
            }

            if (this.props.isProjectSubActivity) {
                classId = '-1';
            }

            let isError = false;
            let errorList: any;
            await _backgroundService
                .RequestAssignmentFilesDownloadAsync(activityId, classId)
                .then((responseData: Response) => {
                    return responseData;
                })
                .then((responseData: Response) => {
                    if (responseData.status !== 200) {
                        isError = true;
                    }
                    return responseData;
                })
                .then((response: any) => {
                    if (isError) {
                        errorList = response;
                    }
                });

            if (isError) {
                Object.keys(errorList).forEach((key: any) => {
                    Notification.setNotification('error', T.t(errorList[key]), 'topRight');
                });
            }

            if (!isError) {
                Notification.setNotification('success', T.t('r_assignment_all_download_info'), 'topRight');
            }

        } catch {
            Notification.setNotification('error', T.t('r_default_error_message'), 'topRight');
        }
    }

    checkPlagiarism = async () => {
        try {
            let classId = '-1';
            let activityId = '';
            if (this.props.activityId) {
                activityId = this.props.activityId
            } else {
                activityId = this.props.assignmentGradeInformation!.activityId;
            }

            let isError = false;
            let errorList: any;
            await _backgroundService
                .RequestPlagiarismControlAsync(activityId, classId)
                .then((responseData: Response) => {
                    return responseData;
                })
                .then((responseData: Response) => {
                    if (responseData.status !== 200) {
                        isError = true;
                    }
                    return responseData;
                })
                .then((response: any) => {
                    if (isError) {
                        errorList = response;
                    }
                });

            if (isError) {
                Object.keys(errorList).forEach((key: any) => {
                    Notification.setNotification('error', T.t(errorList[key]), 'topRight');
                });
            }

            if (!isError) {
                Notification.setNotification('success', T.t('r_assignment_plagiarism_info'), 'topRight');
            }

        } catch {
            Notification.setNotification('error', T.t('r_default_error_message'), 'topRight');
        }
    };

    clickToGetReport = async (plagiarismRemoteId: any) => {
        try {
            if (plagiarismRemoteId !== null) {
                if (plagiarismRemoteId !== "") {
                    let isError = false;
                    let errorList: any;
                    let rUrl = "";
                    await _backgroundService
                        .RequestPlagiarismReportUrlAsync(plagiarismRemoteId)
                        .then((responseData: Response) => {
                            if (responseData.status !== 200) {
                                isError = true;
                                return "";
                            } else {
                                return responseData.json();
                            }
                        })
                        .then((response: any) => {
                            if (isError) {
                                errorList = response;
                            } else {
                                rUrl = response;
                            }
                        });

                    if (isError) {
                        Object.keys(errorList).forEach((key: any) => {
                            Notification.setNotification('error', T.t(errorList[key]), 'topRight');
                        });
                    }

                    if (!isError) {
                        window.open(rUrl, '_blank', 'noopener,noreferrer');
                    }
                }
            }
        } catch {
            Notification.setNotification('error', T.t('r_default_error_message'), 'topRight');
        }
    };

    handleScoreChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const value = event.currentTarget.value;
        const inputID = event.currentTarget.dataset.id ?? '';

        if (value === '-') {
            this.updateScoreTable(inputID, null);
        } else {
            const numericValue = parseInt(value, 10);
            if (value === '' || (numericValue >= 0 && numericValue <= 100 && !isNaN(numericValue))) {
                this.updateScoreTable(inputID, value);
            }
        }
    };

    updateScoreTable = (inputID: string, score: any) => {
        const updatedScoreTable = this.state.scoreTable.map((item: any) =>
            item.id === inputID ? { id: item.id, score: score, status: item.status } : item
        );

        this.setState({
            ...this.state,
            scoreTable: updatedScoreTable,
            derivedState: true
        });
    };
    onPressEnter = (e: React.KeyboardEvent<HTMLInputElement>, inputId: string | null) => {
        const id = inputId || '';
        const dataScore = e.currentTarget.value || '';
        const score = parseInt(dataScore, 10);

        if (e.key === '-' || e.key === '+') {
            e.preventDefault();
        }

        if (e.key === 'Enter') {

            this.onSaveGrade(id, score);
        }
    };

    onSaveGrade(studentId: string, score: number) {
        if (score) {
            const classId = this.props.coursePageClassId!;
            const activityId = this.props.assignmentGradeInformation ? this.props.assignmentGradeInformation.activityId : '';

            this.props.dispatch(
                Actions.getAssignmentGradeSaveGrade(studentId, score, classId, activityId!, false, 'getAssignmentGradeSaveGrade', 'get')
            );
            const updatedScoreTable = this.state.scoreTable.map((item: any) =>
                item.id === studentId ? { id: item.id, score: item.score, status: 'loading' } : item
            );

            this.setState({
                ...this.state,
                scoreTable: updatedScoreTable
            });
        }
    }

    setClose = (refresh: boolean = false) => {
        if (this.props.onClose) {
            this.props.onClose(refresh);
        }
    };


    onPageChange = (page: number) => {
        this.state.filters.page = page;
        this.setState(this.state);
        this.setState({ derivedState: false });
        this.getAssignmentGradeStudentList();
    };

    setCloseModal = () => {
        this.setClose();
    };

    componentWillUnmount() {
        this.props.dispatch(Actions.setAssignmentGradeStudentList(null));
        this.props.dispatch(Actions.setAssignmentGradeSaveGrade(null));
    }


    triggerMessageModal = () => {
        this.setState({
            isMessageModelOpen: !this.state.isMessageModelOpen,
        });
    };

    bulkGrade = () => {
        if (this.state.bulkScore > -1) {
            const classId = this.state.currentTab === '_allStudentsTab' ? '-1' : this.props.coursePageClassId!
            if (this.state.bulkScore > 100) {
                Notification.setNotification('error', T.t('r_assignment_grade_limit'), 'topRight');
                return;
            }

            this.props.dispatch(
                Actions.getAssignmentBulkGrade(classId, this.props.activityId!, this.state.bulkScore, 'getAssignmentBulkGrade', 'get')
            );
        }
    };

    gradeInformation = (totalStudent: number | undefined, uploadedStudent: number | undefined, notUploadedStudent: number | undefined, notEvaluated: number | undefined) => {
        return (
            <div className="d-flex justify-content-between counter-blocks">
                <button className={`assignment-grade-info ${this.state.isGradeInfoType === GradeInfoTypes.TotalStudent && 'active'}`} onClick={() => this.toggleActive(GradeInfoTypes.TotalStudent)}>
                    <div className="media-body">
                        <div className="d-flex justify-content-between align-items-center">
                            <h4 className='mt-1'>{totalStudent ?? 0}</h4>
                        </div>
                        <div className='d-flex justify-content-between align-items-center'>
                            <span>{T.t('r_total_participants')}</span>
                            <input checked={this.state.isGradeInfoType === GradeInfoTypes.TotalStudent} type="radio" className='assignment-grade-radio-button' />
                        </div>
                    </div>
                </button>
                &nbsp;
                <button className={`assignment-grade-info ${this.state.isGradeInfoType === GradeInfoTypes.UploadedStudent && 'active'}`} onClick={() => this.toggleActive(GradeInfoTypes.UploadedStudent)}>
                    <div className="media-body" style={{ backgroundColor: 'blue !important' }}>
                        <div className="d-flex justify-content-between align-items-center">
                            <h4 className='mt-1'>{uploadedStudent ?? 0}</h4>
                            <i className="counter-blocks-progress">
                                {uploadedStudent ? '%' + Math.floor((uploadedStudent * 100) / totalStudent!) : 0}
                            </i>
                        </div>
                        <div className='d-flex justify-content-between align-items-center'>
                            <span>{T.t('r_num_of_students_uploaded_file')}</span>
                            <input checked={this.state.isGradeInfoType === GradeInfoTypes.UploadedStudent} type="radio" className='assignment-grade-radio-button' />
                        </div>
                    </div>
                </button>
                &nbsp;
                <button className={`assignment-grade-info ${this.state.isGradeInfoType === GradeInfoTypes.NotUploadedStudent && 'active'}`} onClick={() => this.toggleActive(GradeInfoTypes.NotUploadedStudent)}>
                    <div className="media-body">
                        <div>
                            <div className='d-flex justify-content-between align-items-center'>
                                <h4 className='mt-1'>{notUploadedStudent ?? 0}</h4>
                                <i className="counter-blocks-progress">
                                    {notUploadedStudent ? '%' + Math.floor((notUploadedStudent * 100) / totalStudent!) : 0}
                                </i>
                            </div>
                            <div className='d-flex justify-content-between align-items-center'>
                                <span>{T.t('r_num_of_file_not_uploaded_students')}</span>
                                <input checked={this.state.isGradeInfoType === GradeInfoTypes.NotUploadedStudent} type="radio" className='assignment-grade-radio-button' />
                            </div>
                        </div>
                    </div>
                </button>
                &nbsp;
                <button className={`assignment-grade-info ${this.state.isGradeInfoType === GradeInfoTypes.NotEvaluated && 'active'}`} onClick={() => this.toggleActive(GradeInfoTypes.NotEvaluated)}>
                    <div className="media-body">
                        <div >
                            <div className='d-flex justify-content-between align-items-center'>
                                <h4 className='mt-1'>{notEvaluated ?? 0}</h4>
                                <i className="counter-blocks-progress">
                                    {notEvaluated ? '%' + Math.floor((notEvaluated * 100) / totalStudent!) : 0}
                                </i>
                            </div>
                            <div className='d-flex justify-content-between align-items-center'>
                                <span>{T.t('r_num_of_not_graded_students')}</span>
                                <input checked={this.state.isGradeInfoType === GradeInfoTypes.NotEvaluated} type="radio" className='assignment-grade-radio-button' />
                            </div>
                        </div>
                    </div>
                </button>
            </div>
        )
    }

    assigmentListining = (totalStudent: number | undefined, uploadedStudent: number | undefined, showPlagiarismControls: boolean | undefined) => {
        return (
            <div className="listing-header">
                <div className="d-flex justify-content-between mb-3">
                    <h2>
                        {T.t('r_participants')}
                        <span className="ml-2 lead-notification">{totalStudent}</span>
                    </h2>
                    <div className="d-inline-flex">
                        <ProgressCircle
                            percent={uploadedStudent ? Math.floor((uploadedStudent * 100) / totalStudent!) : 0}
                        />
                    </div>
                </div>
                <div className="d-flex justify-content-between position-relative">
                    <div className="assignment-btn-grid">
                        <button
                            className="category-tag-circle btn tag-gray theme-tooltip mr-2"
                            onClick={() => this.triggerMessageModal()}
                        >
                            <i className="material-icons"> save_alt</i> {T.t('r_grade_all_assignments')}
                        </button>
                        {Common.HasPermission(SecurityContextType.Activity, SecurityPermissionType.Activity_Assignment_DownloadAssignmentResponses, this.props.coursePageActivityId!) &&
                            <>
                                <button
                                    className="category-tag-circle btn tag-gray theme-tooltip mr-2"
                                    onClick={() => this.downloadZip(false)}
                                >
                                    <i className="material-icons"> save_alt</i> {T.t('r_download_class_assignments')}
                                </button>
                                <button
                                    className="category-tag-circle btn tag-gray theme-tooltip mr-2"
                                    onClick={() => this.downloadZip(true)}
                                >
                                    <i className="material-icons"> save_alt</i> {T.t('r_download_all_assignments')}
                                </button>
                            </>
                        }

                        {showPlagiarismControls &&
                            <button
                                className="category-tag-circle btn tag-gray theme-tooltip mr-2"
                                onClick={() => this.checkPlagiarism()}
                            >
                                {T.t('r_check_plagiarism')}
                            </button>
                        }
                    </div>
                </div>
            </div>
        )
    }

    getPlagiarismMessage = (item: any) => {

        const { plagiarismRemoteId, plagiarismRate } = item;

        if (plagiarismRemoteId === null) {
            return T.t('r_plagiarism_not_checked');
        }

        if (plagiarismRate < 0) {
            return plagiarismRate === -1
                ? T.t('r_plagiarism_not_complate')
                : T.t('r_plagiarism_not_works');
        }

        return T.t('r_plagiarism_rate_is').replace('{0}', plagiarismRate);
    };



    getTooltipMessage = (item: any) => {
        const { uploadChanceIsPassed, downloadLink } = item;
        if (uploadChanceIsPassed) {
            return downloadLink === null
                ? T.t('r_activity_task_deadline_IsEnd')
                : T.t('r_activity_uploaded_successfull');
        } else {
            return downloadLink === null
                ? T.t('r_activity_assignment_not_uploaded')
                : T.t('r_activity_uploaded_successfull');
        }
    };

    bulkGradeOnChange = (e: any) => {
        if (e) {
            this.setState({ bulkScore: e.target.value });
        }
    }

    static getDerivedStateFromProps(props: IAssignmentGradeProps, state: any) {
        let hasNewState = false;
        let newState = { ...state };

        if (props.results?.length && !state.derivedState) {
            hasNewState = true;

            const scoreArray = props.results.map((student: IAssignmentGradeStudentItem) => {
                const stateItem = state.scoreTable?.find((state_item: any) => student.userId === state_item.id);
                return {
                    id: student.userId,
                    score: stateItem ? stateItem.score : student.score,
                    status: 'awaiting',
                    isGraded: stateItem ? stateItem.score : student.score,
                };
            });
            const uniqueUpdatedScoreTable = scoreArray.filter(
                (item: any) => !newState.scoreTable.some((existingItem: any) => existingItem.id === item.id)
            );
            newState.scoreTable = newState.scoreTable.concat(uniqueUpdatedScoreTable);

        }

        if (props.assignmentGradeSaveResult && props.assignmentGradeSaveResult.status === 'Saved') {
            hasNewState = true;
            const updatedScoreTable = state.scoreTable.map((item: any) =>
                item.id === props.assignmentGradeSaveResult!.userId
                    ? { ...item, status: 'Saved' }
                    : item
            );
            const uniqueUpdatedScoreTable = updatedScoreTable.filter(
                (item: any) => !newState.scoreTable.some((existingItem: any) => existingItem.id === item.id)
            );
            newState.scoreTable = newState.scoreTable.concat(uniqueUpdatedScoreTable);
        }

        return hasNewState ? newState : null;
    }

    validateTabAndChange = (tabName: string) => {
        this.setState({ currentTab: tabName })
    }

    public async onMessageModalClick(item: any) {
        try {
            await this.state.handleMessageModal(true);

            const data = await messagesService.RequestGetOriginMessageAsync(item.userId);

            if (data && data.length > 0) {
                this.dispatchGetMessageList(item, data);
            } else {
                this.dispatchSetMessageList(item);
            }
        } catch (error) {
            console.error("Error handling message click:", error);
        }
    }

    private dispatchGetMessageList(item: any, data: any) {
        this.props.dispatch(
            MessagePageActions.getMessageListAction({
                skip: 0,
                take: 10,
                originMessageId: data,
                contextType: 0,
                contextId: item.userId,
                imageUrl: item.userAvatar,
                chatTitleText: item.userFullName,
                spinnerId: 'getMessageListAction',
                spinnerType: 'get',
            })
        );
    }

    private dispatchSetMessageList(item: any) {
        this.props.dispatch(
            MessagePageActions.setMessageListAction([], '-1', 0, 100, 0, item.userFullName, item.userAvatar, item.userId, 0, 'getMessageListAction', 'set')
        );
    }

    toggleActive = (type: GradeInfoTypes) => {
        this.setState({ isGradeInfoType: type, filters: { ...this.state.filters, page: 1 } }, () => {
            this.getAssignmentGradeStudentList();
        });
    };


    render() {
        if (this.state.redirectMessagesPage) {
            return <Redirect push={true} to={window.appSettings.DEFAULT_URL + '/u/Message/Index/?userId=' + this.state.userId + '&userName=' + this.state.userName} />
        }

        const loadingSpaces = 64;
        const { results } = this.props;
        const { programName, courseName } = this.props.coursePageclassInformation || {};
        const { activityName, activityDescription, totalStudent, uploadedStudent, notUploadedStudent, notEvaluated, showPlagiarismControls } = this.props.assignmentGradeInformation || {};


        return (
            <div>
                <ChatPanel
                    onClose={() => this.state.handleMessageModal(false)}
                    isModalOpen={this.state.isMessageModalOpen}
                    isSubmain={true}
                    id={1}
                />
                <Modal
                    modalClassName="modal fade modal-from-right assignment-modal show"
                    isOpen={this.props.modalIsOpen}
                    toggle={this.setCloseModal}
                    style={{ minWidth: '600px' }}
                >
                    <div className="modal-dialog" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">
                                    <i className="mr-2 material-icons">note_add</i>
                                    {T.t('r_assignment_grading')}
                                </h5>
                                <button type="button" className="close" data-dismiss="modal" onClick={this.setCloseModal} aria-label="Close">
                                    <i className="material-icons">close</i>
                                    <span>{T.t('r_gen_close')}</span>
                                </button>
                            </div>
                            <div className="modal-body" style={{ padding: '30px 30px 0 30px' }}>
                                <BaseModal
                                    minWidth={650}
                                    modalIsOpen={this.state.isMessageModelOpen}
                                    onClose={this.triggerMessageModal}
                                    headerState={T.t('r_grade_all_assignments_modal_header')}
                                    headerIcon={'clock'}
                                    modalFooter={() => {
                                        return (<div className="modal-footer">
                                            <Button text={T.t('r_send')} button_type={'primary'} size={'medium'} onClick={this.bulkGrade} iconPosition='left' materialicon='send'/>
                                        </div>)
                                    }}>
                                    <BulkGrade activityId={this.props.activityId} isProjectSubActivity={false} bulkGradeOnChange={this.bulkGradeOnChange} />
                                </BaseModal>
                                <div className="homework-title">
                                    <div className="d-flex justify-content-between">
                                        <div>
                                            <span className="mb-2 d-block">{courseName + ' / ' + programName}</span>
                                        </div>
                                    </div>
                                    <h2 className="mb-2">{activityName}</h2>
                                    <p dangerouslySetInnerHTML={{ __html: activityDescription! }} />
                                </div>
                                {this.gradeInformation(totalStudent, uploadedStudent, notUploadedStudent, notEvaluated)}
                                <div className="assignment-listing">
                                    {this.assigmentListining(totalStudent, uploadedStudent, showPlagiarismControls)}
                                    <ActivityAssignmentGradeModalTabs
                                        currentTab={this.state.currentTab}
                                        formikProps={this.props}
                                        validateTabAndChange={this.validateTabAndChange}
                                    />
                                    <div className="lead-search-bar" style={{ position: 'relative', textAlign: 'right', marginTop: 15, marginBottom: 15 }}>
                                        <div className="question-filter p-0">
                                            <SearchInput
                                                triggerSearchBox={(val: boolean) => this.triggerSearchBox(val)}
                                                isSearchBoxOpen={this.state.isSearchBoxOpen}
                                                onChange={(event: any) => this.setState({
                                                    ...this.state,
                                                    filters: {
                                                        ...this.state.filters,
                                                        query: event.target.value
                                                    }
                                                })}
                                                onKeyUp={(event: any) => { this.getAssignmentGradeStudentList() }}
                                            />
                                        </div>
                                    </div>
                                    <Loading spinnerId={'getAssignmentGradeStudentList'} width={'100%'}>
                                        <div style={{ backgroundColor: '#eeede9' }}>
                                            <ContentLoader
                                                speed={2}
                                                backgroundColor="#f3f3f3"
                                                foregroundColor="#ecebeb"
                                                viewBox="0 0 700 400"
                                                style={{ width: '100%' }}
                                            >
                                                <circle cx="36" cy="64" r="20" />
                                                <rect x="66" y="60" rx="5" ry="5" width="600" height="12" />
                                                <circle cx="36" cy={loadingSpaces + 60} r="20" />
                                                <rect x="66" y={loadingSpaces + 56} rx="5" ry="5" width="600" height="12" />
                                                <circle cx="36" cy={loadingSpaces + 120} r="20" />
                                                <rect x="66" y={loadingSpaces + 116} rx="5" ry="5" width="600" height="12" />
                                                <circle cx="36" cy={loadingSpaces + 180} r="20" />
                                                <rect x="66" y={loadingSpaces + 176} rx="5" ry="5" width="600" height="12" />
                                                <circle cx="36" cy={loadingSpaces + 240} r="20" />
                                                <rect x="66" y={loadingSpaces + 236} rx="5" ry="5" width="600" height="12" />
                                            </ContentLoader>
                                        </div>
                                    </Loading>
                                    <div id='getAssignmentGradeStudentList_Content' >
                                        <table className="table table-striped">
                                            <tbody>
                                                {(results && results.length > 0)
                                                    ? results.map((item: IAssignmentGradeStudentItem) => {
                                                        const stateItem = this.state.scoreTable?.find((state_item: any) => item.userId === state_item.id);
                                                        let itemScore = stateItem?.score;
                                                        const itemStatus = stateItem?.status;
                                                        const truncatedUserFullName = _lodash.truncate(item.userFullName, {
                                                            length: 35,
                                                            omission: '...'
                                                        });

                                                        const truncatedUsername = _lodash.truncate(item.userName, {
                                                            length: 35,
                                                            omission: '...'
                                                        });
                                                        return (
                                                            <tr key={item.userId}>
                                                                <td>
                                                                    <div className="d-flex align-content-between">
                                                                        <div className="media align-items-center">
                                                                            <SecureImage
                                                                                imageUrl={item.userAvatar ?? ''}
                                                                                style={{}}
                                                                                class={'media align-items-center mr-2'}
                                                                            />
                                                                            <div className="media-body">
                                                                                <span className="text-truncate">{truncatedUserFullName} </span>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </td>
                                                                <td >
                                                                    <Tooltip data={item.userName} position='top'>
                                                                        <span className="text-truncate" id="userName">
                                                                            {truncatedUsername}
                                                                        </span>
                                                                    </Tooltip>
                                                                </td>
                                                                <td className="text-center">
                                                                    <OverlayTrigger
                                                                        key="top"
                                                                        trigger="click"
                                                                        rootClose={true}
                                                                        rootCloseEvent="mousedown"

                                                                        overlay={
                                                                            <Popover id="popover-contained" style={{
                                                                                minWidth: '370px',
                                                                                boxShadow: 'rgb(0 0 0 / 30%) 0px 1px 3px 2px'
                                                                            }}>
                                                                                {
                                                                                    <div className="row" style={{ minWidth: '370px', height: '120px', padding: '10px 25px' }}>
                                                                                        <div className="col-4" style={{ display: 'flex', alignItems: 'center', overflow: 'hidden', justifyContent: 'center' }}>
                                                                                            <SecureImage
                                                                                                imageUrl={item.userAvatar ?? ''}
                                                                                                style={{
                                                                                                    flexShrink: '0',
                                                                                                    maxWidth: '100%',
                                                                                                    maxHeight: '100%'
                                                                                                }}
                                                                                                class={'media align-items-center mr-2'}
                                                                                            />
                                                                                        </div>
                                                                                        <div className="col-8">
                                                                                            {T.t('r_gen_student')}<br /><b>{truncatedUserFullName}</b><br />{programName} <br />
                                                                                            <button className='message_btn alms-btn btn-default btn-icon' onClick={() => this.onMessageModalClick(item)}>
                                                                                                <img src={_common.GetDefaultIcons('messageoutline')} className='mr-1' />{T.t('r_send_message')}
                                                                                            </button>
                                                                                        </div>

                                                                                    </div>
                                                                                }
                                                                            </Popover>
                                                                        }
                                                                    >
                                                                        <div className="list-icons text-center">
                                                                            <Tooltip data={T.t('r_show_more_information')} position='top'>
                                                                                <i className={'material-icons opacity-3'} id="info">
                                                                                    info
                                                                                </i>
                                                                            </Tooltip>
                                                                        </div>
                                                                    </OverlayTrigger>


                                                                </td>
                                                                {this.state.currentTab == '_allStudentsTab' &&
                                                                    <td className="text-center">
                                                                        <Tooltip data={T.t('r_gen_class_name')} position='top'>
                                                                            <span className="assignment-text" id="className">
                                                                                {item.className}
                                                                            </span>
                                                                        </Tooltip>
                                                                    </td>
                                                                }
                                                                <td className="text-center">
                                                                    <Tooltip data={T.t('r_assignment_grade_file_upload_attempts')} position='top'>
                                                                        <span className="assignment-text" id="uploadedAndTotalCount">
                                                                            {item.uploadedAndTotalCount}
                                                                        </span>
                                                                    </Tooltip>
                                                                </td>
                                                                <td className="text-center">
                                                                    <UncontrolledTooltip placement="top" target="lastUploadTime">
                                                                        {T.t('r_assignment_grade_file_upload_time')}
                                                                    </UncontrolledTooltip>
                                                                    <span className="assignment-text" id="lastUploadTime">
                                                                        {item.lastUploadTime && Moment(item.lastUploadTime ?? '').format(
                                                                            _common.findDateFormat(this.props.userPreferences!, true)
                                                                        )}
                                                                    </span>
                                                                </td>
                                                                <td className="text-center">
                                                                    {item.showPlagiarismControls && (
                                                                        <div className="list-icons">
                                                                            <Tooltip data={this.getPlagiarismMessage(item)} position='top'>
                                                                                <i onMouseDown={() => this.clickToGetReport(item.plagiarismRemoteId)} className={`material-icons ${item.plagiarismRemoteId === null ? "opacity-3" : (item.plagiarismRate < 0) && "red"}`}
                                                                                    id="_plagiarismReport"
                                                                                >
                                                                                    copyright
                                                                                </i>
                                                                            </Tooltip>
                                                                        </div>
                                                                    )}
                                                                </td>
                                                                <td className="text-center">
                                                                    <div className="list-icons">
                                                                        <Tooltip data={this.getTooltipMessage(item)} position='top'>
                                                                            <i className={`material-icons ${item.downloadLink ? "green" : item.uploadChanceIsPassed ? "red" : "opacity-3"}`}>
                                                                                alarm
                                                                            </i>
                                                                        </Tooltip>
                                                                    </div>
                                                                </td>
                                                                {Common.HasPermission(SecurityContextType.Activity, SecurityPermissionType.Activity_Assignment_DownloadAssignmentResponses, this.props.coursePageActivityId!) &&
                                                                    <td className="text-center">

                                                                        <div className="d-flex justify-content-between align-items-center">
                                                                            <span>
                                                                                {item.downloadLink ? (
                                                                                    <Tooltip data={T.t('r_download_homework')} position='top'>
                                                                                        <i
                                                                                            className="material-icons"
                                                                                            id="_downloadFile"
                                                                                            onMouseDown={() =>
                                                                                                this.clickToDownload(
                                                                                                    item?.downloadLink?.filePath ?? '##',
                                                                                                    item?.downloadLink?.fileName ?? ''
                                                                                                )
                                                                                            }
                                                                                        >
                                                                                            attach_file
                                                                                        </i>
                                                                                    </Tooltip>
                                                                                ) : (
                                                                                    <p id="_downloadFile"> </p>
                                                                                )}
                                                                            </span>
                                                                            <span className='d-flex align-items-center' style={{ border: 'none' }}>
                                                                                {itemStatus === 'loading' ? (
                                                                                    <i
                                                                                        className="material-icons status-icon"
                                                                                        style={{
                                                                                            fontSize: '21px',
                                                                                            color: 'black',
                                                                                            verticalAlign: 'text-bottom'
                                                                                        }}
                                                                                    >
                                                                                        sync
                                                                                    </i>
                                                                                ) : itemStatus === 'Saved' && (
                                                                                    <React.Fragment>
                                                                                        <Tooltip data={T.t('r_assignment_grade_save_grade_successful_message')} position='top'>
                                                                                            <i
                                                                                                className="material-icons status-icon"
                                                                                                id="grade_is_saved"
                                                                                                style={{
                                                                                                    fontSize: '21px',
                                                                                                    color: 'green',
                                                                                                    verticalAlign: 'text-bottom'
                                                                                                }}
                                                                                            >
                                                                                                check_circle
                                                                                            </i>
                                                                                        </Tooltip>
                                                                                    </React.Fragment>
                                                                                )}
                                                                                <input
                                                                                    maxLength={100}
                                                                                    className="input"
                                                                                    placeholder={T.t('r_enter_note')}
                                                                                    data-id={item.userId}
                                                                                    data-score={itemScore}
                                                                                    style={{ width: '100px' }}
                                                                                    onChange={this.handleScoreChange}
                                                                                    value={itemScore == -1 ? "" : itemScore}
                                                                                    onBlur={() => this.onSaveGrade(item.userId ? item.userId : '', itemScore)}
                                                                                    onFocus={this.handleScoreChange}
                                                                                    onKeyDown={(e: React.KeyboardEvent<HTMLInputElement>) => this.onPressEnter(e, item.userId)}
                                                                                    type={itemScore == -1 ? "text" : "number"}
                                                                                    disabled={this.props.isSimulate}
                                                                                />
                                                                            </span>
                                                                        </div>
                                                                    </td>
                                                                }
                                                            </tr>
                                                        );
                                                    })
                                                    :
                                                    (this.state.currentTab === '_classStudentsTab' && this?.props?.results?.length == 0) &&
                                                    <div>
                                                        <h5 style={{ marginTop: 15, textAlign: 'center', marginBottom: 50 }}>
                                                            {
                                                                T.t('r_assignment_grade_student_list_message')
                                                            }
                                                        </h5>
                                                    </div>
                                                }
                                            </tbody>
                                        </table>
                                    </div>

                                    {(results && results.length > 0) && (
                                        <div className="row-options justify-content-end">
                                            <div
                                                className="page-sorting d-flex align-items-center justify-content-center"
                                                style={{ marginTop: '5px' }}
                                            />
                                            <Paginate filters={this.props.filters} onPageChange={this.onPageChange} />
                                        </div>
                                    )}
                                </div>
                            </div>
                            <div className="modal-footer d-block">
                                <div className="row">
                                    <div className="col-md-4">
                                        <Button
                                            button_type={'secondary'}
                                            text={T.t('r_cancel')}
                                            size={'large'}
                                            onClick={this.setCloseModal}
                                            iconPosition='left'
                                            materialicon='close' />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    ;
                </Modal >
            </div >

        );
    }
}

const mapStateToProps = (state: IAppState, ownProps: IAssignmentGradeProps): IAssignmentGradeProps => {
    if (!state) {
        return ownProps;
    }
    const newProps: IAssignmentGradeProps = Object.assign({}, ownProps, {
        coursePageClassId: state.coursePage.coursePageClassId,
        courseContentWeekActivities: state.coursePage.courseContentWeekActivities,
        activityCardItems: state.coursePage.activityCard,
        coursePageActivityId: state.coursePage.coursePageActivityId,
        coursePageclassInformation: state.coursePage.coursePageclassInformation,
        assignmentGradeInformation: state.coursePage.assignmentGradeInformation,
        assignmentGradeSaveResult: state.coursePage.assignmentGradeSaveResult,
        filters: state.coursePage.assignmentGradeStudentList ? state.coursePage.assignmentGradeStudentList.filters : {},
        results: state.coursePage.assignmentGradeStudentList ? state.coursePage.assignmentGradeStudentList.results : [],
        userPreferences: state.profile.userPreferences.preferences,
        groupId: state.assignment.groupId,
        isSimulate: state.login.identitiy.isSimulate
    });
    return newProps;
};

const dispatchProps = (dispatch: Dispatch<IAction>) => {
    return {
        dispatch
    };
};

const areStatesEqual = (next: IAppState, prev: IAppState) => {
    return false;
};

const CProcessingActivity = connect(
    mapStateToProps,
    dispatchProps,
    null,
    { areStatesEqual }
)(ReportModal);

export default CProcessingActivity;
